import LiveChat from "@/plugins/livechat";

export default {
    state: {
        livechatApp: { app: {}, isLoaded: false },
        ticketHelpTopicList: { list: [], isLoaded: false },
    },
    actions: {
        async getLiveChatApp({ state, commit }, chatId) {

            const result = await this.makeRequest({
                reqFunc: this.apiService.getLiveChatApp,
            });

            if (result && result.data && !state.livechatApp.isLoaded) {

                const lc = result.data.data;

                if (chatId) lc.params.chatId = chatId;

                const app = new LiveChat(lc.params);

                commit('SET_LIVECHAT_APP', app);
            }
        },
        async getTicketHelpTopicList({ commit }) {
            const result = await this.makeRequest({
                reqFunc: this.apiService.getTicketTopics
            });
            
            if (result && result.data) {
                commit('SET_TICKET_HELP_TOPIC_LIST', result.data.data.list);
                return result.data.data.list;
            }

            return false;
        }
    },
    mutations: {
        SET_LIVECHAT_APP(state, data) {
            state.livechatApp = {
                app: data,
                isLoaded: true,
            };
        },
        SET_TICKET_HELP_TOPIC_LIST(state, data) {
            state.ticketHelpTopicList = {
                list: data,
                isLoaded: true,
            };
        }  
    },
    getters: {
        livechatApp: state => state.livechatApp,
        ticketHelpTopicList: state => state.ticketHelpTopicList,
    }
}